import React from 'react'

const About = () => {
  return (
    <div className='bg-white sm:pb-20 sm:mb-10 sm:pt-10'>
        <div className='pl-5 md:pl-10 pt-5 md:ml-10 mt-5 w-full'>
            <h1 className='text-tertiary font-semibold text-2xl md:text-5xl p-2 md:pl-10 md:ml-10'>About Goldyvhista Hubz</h1>
        </div>
        <div className='px-5 md:pl-10 pt-3 md:pt-5 mx-1 md:m-5 w-full md:w-1/2'>
            <span className='block text-black text-xl pb-3 leading-relaxed'>
                 Goldyvhista Hubz is your premium destination for quality kitchen utensils, kiddies essentials, household supplies, and souveniers. 
            </span>
            <span  className='block text-black text-xl pb-3 leading-relaxed'>
            Stop compromising quality for affordability. With Goldyvhista Hubz, you can enjoy exceptional deals on essential products that will make your life easier. From sleek kitchen utensils to captivating wall decors, we've curated a diverse selection of items that meet all your household needs.  
            </span>
            <span className='block text-black text-xl pb-3 leading-relaxed'>
              Shop to your heart's delight.  Call or DM 08145887534 to place orders. 
            </span>
            <span  className='block text-black text-xl pb-3 leading-relaxed'>
            Elevate the aesthetics of your home. Make your life easier. 
            </span>
        </div>
    </div>
  )
}

export default About